import { EntityService, GlobalService } from "app/core/services";
import { Observable } from "rxjs";
import { Deductible } from "../model/deductible";
import { Injectable } from "@angular/core";
import { DeductibleMultimedia } from "../model/deductibleMultimedia";

@Injectable()
export class DeductibleService {
    constructor(
        private http: GlobalService,
        private entityService: EntityService
    ) { }

    getById(id: number, sinester: number): Observable<Deductible[]> {
        const url = `deductibles/${id}/${sinester}`;
        return this.http
            .get(url)
            .map((res) => this.entityService.extractData<Deductible[]>(res))
            .map((data) => {
                return data.map((dataItem) => {
                    const claim = new Deductible();
                    return this.entityService.copy(dataItem, claim);
                });
            });
    }


    GetSinesters(codInsured: number): Observable<Deductible[]> {
        const url = `deductibles/sinesters/${codInsured}`;
        return this.http
            .get(url)
            .map((res) => this.entityService.extractData<Deductible[]>(res))
            .map((data) => {
                return data.map((dataItem) => {
                    const claim = new Deductible();
                    return this.entityService.copy(dataItem, claim);
                });
            });
    }


    getAll(): Observable<Deductible[]> {
        const url = `deductibles`;
        return this.http
            .get(url)
            .map((res) => this.entityService.extractData<Deductible[]>(res))
            .map((data) => {
                return data.map((dataItem) => {
                    const claim = new Deductible();
                    return this.entityService.copy(dataItem, claim);
                });
            });
    }

    getMultimedia(deductibleId: number): Observable<DeductibleMultimedia[]> {
        const url = `deductibles/Multimedia/${deductibleId}`;
        return this.http
            .get(url)
            .map((res) => this.entityService.extractData<DeductibleMultimedia[]>(res))
            .map((data) => {
                return data.map((dataItem) => {
                    const deductible = new DeductibleMultimedia();
                    return this.entityService.copy(dataItem, deductible);
                });
            });
    }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/services/deductible.service.ts